import { DateConverter } from '@/model/converters/datesConverters';
import { CustomConverter, JsonObject, JsonProperty, Optional } from 'json-ts-mapper';

@JsonObject
export class ReglementCommandeSAS {
  constructor (
    modeReglement?: string,
    numDomiciliationBancaire?: number,
    codeBic?: string,
    iban?: string,
    prixUnitaireBase?: number,
    montantTotal?: number,
    tauxEscompte?: number,
    prixUnitaireVente?: number,
    dateEcheance?: Date
  ) {
    this.modeReglement = modeReglement as any;
    this.numDomiciliationBancaire = numDomiciliationBancaire as any;
    this.codeBic = codeBic as any;
    this.iban = iban as any;
    this.prixUnitaireBase = prixUnitaireBase as any;
    this.montantTotal = montantTotal as any;
    this.tauxEscompte = tauxEscompte as any;
    this.prixUnitaireVente = prixUnitaireVente as any;
    this.dateEcheance = dateEcheance as any;
  }

  @JsonProperty(String)
  modeReglement?: string;

  @JsonProperty(Number)
  @Optional
  numDomiciliationBancaire?: number;

  @JsonProperty(String)
  @Optional
  codeBic?: string;

  @JsonProperty(String)
  @Optional
  iban?: string;

  @JsonProperty(Number)
  prixUnitaireBase?: number;

  @JsonProperty(Number)
  montantTotal?: number;

  @JsonProperty(Number)
  tauxEscompte?: number;

  @JsonProperty(Number)
  @Optional
  prixUnitaireVente?: number;

  @JsonProperty(String)
  @CustomConverter(DateConverter)
  dateEcheance?: Date;
}
